import { Action } from './Farm';
import { Plot, adaptPlot } from './Plot';

export interface Field {
  id: string; // CN-0012: UUID-only
  storeId?: string;
  farmId: string; // CN-0012: UUID-only
  name: string;
  area?: number | null;
  location_coords?: string | null;
  description?: string | null;
  actions?: Action[];
  plots?: Plot[];
  farm?: { id: string };  // CN-0012: Backend may return nested farm object
}

export const adaptField = (data: any): Field => ({
  id: data.id,
  storeId: data.storeId ?? data.store_id ?? undefined,
  farmId: data.farmId ?? data.farm_id ?? data.farm?.id, // CN-0012: Backend returns field.farm.id
  name: data.name,
  area: data.area ?? null,
  location_coords: data.location_coords ?? null,
  description: data.description ?? null,
  actions: (data.actions || []).map((a: any) =>
    typeof a === 'string'
      ? { title: '', code: a }
      : { title: a.title, code: a.code, state: a.state },
  ),
  // Support nested hierarchy: field -> plots (aka sections)
  plots: (data.plots || data.sections || data.uchastki || []).map((p: any) => adaptPlot(p)),
  farm: data.farm ? { id: data.farm.id } : undefined,  // CN-0012: Backend returns nested farm object
});
